var r="4.1.1";export{r as version};
//# sourceMappingURL=package.json.js.map
